import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Menu, X, Phone, Mail } from 'lucide-react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/services', label: 'Services' },
    { path: '/about', label: 'About Us' },
    { path: '/contact', label: 'Contact' }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="sticky top-0 z-50 bg-white/95 backdrop-blur-md border-b border-slate-200 shadow-sm">
      <div className="container mx-auto px-6">
        {/* Top bar */}
        <div className="hidden md:flex items-center justify-end gap-6 py-2 text-sm border-b border-slate-100">
          <a href="tel:+919437046671" className="flex items-center gap-2 text-slate-600 hover:text-[#1B5E20] transition-colors">
            <Phone className="h-4 w-4" />
            <span>+91 9437046671</span>
          </a>
          <a href="mailto:SKM.RKL@REDIFFMAIL.COM" className="flex items-center gap-2 text-slate-600 hover:text-[#1B5E20] transition-colors">
            <Mail className="h-4 w-4" />
            <span>SKM.RKL@REDIFFMAIL.COM</span>
          </a>
        </div>

        {/* Main navigation */}
        <div className="flex items-center justify-between py-4">
          {/* Logo */}
          <button 
            onClick={() => navigate('/')}
            className="flex items-center gap-4"
          >
            <img 
              src="https://customer-assets.emergentagent.com/job_ca-firm-site/artifacts/dy4dtb6i_IMG_5726.PNG"
              alt="ICAI Logo"
              className="h-12 w-12 object-contain"
            />
            <div className="flex flex-col">
              <span className="text-2xl md:text-3xl font-bold text-slate-900">
                S.K. Mundhra & Co.
              </span>
              <span className="text-xs md:text-sm text-[#1B5E20] font-medium">
                Chartered Accountants | Since 1991
              </span>
            </div>
          </button>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-8">
            {navLinks.map((link) => (
              <button
                key={link.path}
                onClick={() => navigate(link.path)}
                className={`font-medium transition-colors relative py-2 ${
                  isActive(link.path)
                    ? 'text-[#1B5E20]'
                    : 'text-slate-700 hover:text-[#1B5E20]'
                }`}
              >
                {link.label}
                {isActive(link.path) && (
                  <span className="absolute bottom-0 left-0 right-0 h-0.5 bg-[#1B5E20]"></span>
                )}
              </button>
            ))}
            <Button 
              onClick={() => navigate('/contact')}
              className="bg-#1B5E20 hover:bg-#0D3D13 text-white px-6 shadow-lg hover:shadow-xl transition-all duration-300"
            >
              Get in Touch
            </Button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="lg:hidden p-2 text-slate-700 hover:text-#0D3D13 transition-colors"
          >
            {isMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav className="lg:hidden py-4 border-t border-slate-200 space-y-2">
            {navLinks.map((link) => (
              <button
                key={link.path}
                onClick={() => {
                  navigate(link.path);
                  setIsMenuOpen(false);
                }}
                className={`block w-full text-left px-4 py-3 rounded-lg font-medium transition-colors ${
                  isActive(link.path)
                    ? 'bg-green-100 text-#0D3D13'
                    : 'text-slate-700 hover:bg-slate-100'
                }`}
              >
                {link.label}
              </button>
            ))}
            <div className="pt-2">
              <Button 
                onClick={() => {
                  navigate('/contact');
                  setIsMenuOpen(false);
                }}
                className="w-full bg-#1B5E20 hover:bg-#0D3D13 text-white"
              >
                Get in Touch
              </Button>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
